<template>
    <div class="container-fluid content-wrapper" v-if="variantGroupDetails">
        <p-form @submit="onSubmit">
            <b-row class="content-heading">
                <b-col>
                    <div>{{ isNew ? 'Add' : 'Edit' }} Product Variant Group</div>
                </b-col>
                <b-col cols="auto" class="ms-auto">
                    <p-button variant="primary" type="submit" :is-busy="isBusy">Save</p-button>
                </b-col>
            </b-row>
            <b-row >
                <b-col cols="12" lg="5">
                    <p-input
                        label="Group Name"
                        v-model="variantGroupDetails.groupName"
                        rules="required|max:80"
                        :disabled="!isNew"
                    />
                </b-col>
                <b-col cols="12" lg="5">
                    <p-input
                        label="Group Description"
                        v-model="variantGroupDetails.description"
                        rules="max:1000"
                    />
                </b-col>
                <b-col cols="12" lg="2">
                    <p-select
                        label="Status"
                        v-model="variantGroupDetails.status"
                        :options="status"
                        text-field="value"
                    />
                </b-col>
            </b-row>
            <p-card>
                <b-row>
                    <b-col cols="12">
                        <p-table
                            :items="getItems"
                            :enable-row-selection="false"
                            :fields="fields"
                            :pagination="false"
                            :per-page="500"
                            @row-clicked="(item) => item.isActive = !item.isActive"
                            class="fixed-variant-table"
                        >
                            <template v-slot:above-table>
                                <b-row class="mt-3"
                                >
                                    <b-col>
                                        <p-checkbox
                                            v-model="filterSelected"
                                            size="md"
                                            label="Show Only Selected"
                                        ></p-checkbox>
                                    </b-col>
                                </b-row>
                            </template>

                            <template v-slot:cell(isActive)="{ value, item }">
                                <p-checkbox
                                    v-model="item.isActive"
                                    size="md"
                                ></p-checkbox>
                            </template>
                        </p-table>
                    </b-col>
                </b-row>
            </p-card>
            <b-row class="mt-3">
                <b-col class="text-start">
                    <p-button
                        variant="outline-danger"
                        type="button"
                        :is-busy="isBusy"
                        @click="deleteGroup"
                        v-if="!isNew"
                        >Delete</p-button
                    >
                </b-col>
                <b-col class="text-end">
                    <p-button
                        variant="primary"
                        type="submit"
                        :is-busy="isBusy"
                        >Save</p-button
                    >
                </b-col>
            </b-row>
        </p-form>
    </div>
</template>

<script>
import NavigationGuard from '@/components/mixins/NavigationGuard.js';
import editPage from '@/components/mixins/EditPage';
import axios from 'axios';

export default {
    mixins: [NavigationGuard, editPage],
    components: {},
    data() {
        return {
            isBusy: false,
            filterSelected: false,
            status: [{ value: 'Active' }, { value: 'Inactive' }],
            fields: [
                {
                    key: 'isActive',
                    label: '',
                    thStyle: { width: '60px' },
                    tdStyle: { width: '60px' }
                },
                {
                    key: 'name',
                    label: 'Variants',
                    automaticSearch: true,
                    sortable: true
                },
                {
                    key: 'type',
                    label: 'Type',
                    automaticSearch: true,
                    sortable: true
                }        
            ],
            variantGroupDetails: null
        };
    },
    watch: {
        variantGroupDetails: NavigationGuard.$watcher
    },
    mounted: function() {
        this.loadData();
    },
    computed: {
        getItems() {
            return this.filterSelected
                ? this.variantGroupDetails.productVariantGroupings.filter(
                      x => x.isActive == true
                  )
                : this.variantGroupDetails.productVariantGroupings;
        },
        isVariantLinked() {
            return (
                this.variantGroupDetails.productVariantGroupings.filter(
                    x => x.isActive == true
                ).length > 0
            );
        }
    },
    methods: {
        onSubmit() {
            this.isBusy = true;
            axios
                .post('productvariantgroup', this.variantGroupDetails)
                .then(response => {
                    this.dataSaved();
                    if (this.isNew) {
                        this.$router.push(
                            '/productvariantgroup/' + response.data
                        );
                    }
                    this.$appSuccess(
                            `Variant group details saved successfully.`
                        )
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        loadData() {
            let promise = this.isNew
                ? axios.get('productvariantgroup/new')
                : axios.get('productvariantgroup', { params: { id: this.id } });

            promise.then(resp => {
                this.variantGroupDetails = resp.data;
                this.dataLoaded();
            });
        },

        deleteGroup() {
            if(this.isVariantLinked){
                this.$appError(
                        'Unable to delete variant groups assigned to any variant. Please remove variant group from any variant before attempting to delete.'
                    )
            }else{
                this.isBusy = true;
                axios
                    .post('productvariantgroup/delete', this.variantGroupDetails)
                    .then(() => {
                        this.dataSaved();
                        this.$router.push('/productvariantgroups');
                        this.$appSuccess(`Variant group deleted successfully.`)
                    })
                    .finally(() => {
                        this.isBusy = false;
                    });

            }            
        }
    }
};
</script>

<style lang="scss">
.fixed-variant-table table {
    table-layout: fixed;
    width: 100%;
}
</style>
